import React from "react";
import {Auth} from "aws-amplify";
import {useHistory} from "react-router-dom";
import {Card, CardContent, Grid} from "@mui/material";
import {onError} from "../lib/errorLib";
import {Field, Form, Formik} from "formik";
import {TextField} from "formik-mui";
import LoaderButton from "../components/LoaderButton";
import * as Yup from "yup";
import ZxcvbnTest, {PASS_LEN_MSG, PASS_MIN_LEN} from "../components/PasswordReqs";

export default function ChangePassword() {
    const history = useHistory();
    const requiredMsg = "Required";
    const validationSchema = Yup.object().shape({
        oldPassword: Yup.string().required(requiredMsg),
        password: Yup.string().notOneOf([Yup.ref("oldPassword"), null], "Must not be Old Password").test({
            name: "ZxcvbnTest",
            exclusive: true,
            message: "Password not complex enough",
            "test": ZxcvbnTest,
        }).min(PASS_MIN_LEN, PASS_LEN_MSG).required(requiredMsg),
        confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], "Must match New Password").required(requiredMsg)
    });

    const handleChangeClick = async (values, formikBag) => {
        try {
            const currentUser = await Auth.currentAuthenticatedUser();
            await Auth.changePassword(currentUser, values.oldPassword, values.password);
            history.push("/settings");
        } catch (error) {
            onError(error);
        }
    }

    return (
        <>
            <Formik
                initialValues={{
                    oldPassword: "",
                    password: "",
                    confirmPassword: ""
                }}
                validationSchema={validationSchema}
                onSubmit={handleChangeClick}>
                {(props) =>
                    (<Form>
                        <Card>
                            <CardContent>
                                <Grid container
                                      spacing={3}
                                      direction={"column"}
                                      alignItems={"center"}
                                >
                                    <Grid item>
                                        <Field
                                            autoFocus={true}
                                            name={"oldPassword"}
                                            label={"Old Password"}
                                            component={TextField}
                                            type={"password"}
                                            variant={"outlined"}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <Field
                                            name={"password"}
                                            label={"New Password"}
                                            component={TextField}
                                            type={"password"}
                                            variant={"outlined"}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <Field
                                            name={"confirmPassword"}
                                            label={"Confirm Password"}
                                            component={TextField}
                                            type={"password"}
                                            variant={"outlined"}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <LoaderButton
                                            type="submit"
                                            size="medium"
                                            disabled={!props.isValid}
                                            isLoading={props.isSubmitting}
                                            variant={"contained"}
                                            color={"primary"}
                                        >
                                            Change Password
                                        </LoaderButton>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Form>)}
            </Formik>
        </>
    );
}
